require('./edit');
require('./new');

import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import userProgressMixin from '../../mixins/_user_progress';
import itemSearch from '../../mixins/_item_search';
import modalYahooAuth from '../../components/_modal_yahoo_auth';
import updateStorecreatorData from '../../components/_update_storecreator_data';
import categoryFilter from '../../components/_category_filter';
import itemList from './_item_list_component';
import modalBatchSettings from './_modal_batch_settings';

const view = '[data-view="item-index"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                // 初回商品登録画面表示フラグ
                first_create: false,
                // カテゴリがDBに一つでも登録があるか
                has_categories: false,
                // 初回検索は行われたか
                has_searched: false,
                // 開店済みか
                opened: true,
                // 下書きアイテムリスト
                draft_list: [],
                // カテゴリー一覧
                categories: null,
                // ページキー(カテゴリキー)
                page_key: null,
                // 前回検索条件
                before_search_conditions: null,
                // カテゴリ更新による検索を無効にするか
                disabled_category_filter: false,
                // 商品件数制限エラーメッセージ
                item_limit_error_message: null,
                // YahooMyItemListApiのデータを取得しているか
                is_my_item_list: false,
            };
        },
        mixins: [
            commonMixin,
            flashMessageMixin,
            userProgressMixin,
            itemSearch,
        ],
        /**
         * コンポーネント群
         */
        components: {
            // ヤフーAPIトークン認証チェックコンポーネント
            'modal-yahoo-auth': modalYahooAuth,
            // ストアクリエイターからデータを取得するコンポーネント
            'update-storecreator-data': updateStorecreatorData,
            // 商品リストコンポーネント
            'item-list': itemList,
            // カテゴリ選択コンポーネント
            'category-filter': categoryFilter,
            // 送料無料設定モーダル
            'modal-batch-settings': modalBatchSettings,
        },
        computed: {
            // 下書きアイテムリスト数を返却する
            numOfDraftList: function () {
                return this.draft_list.length;
            },
            // 下書きアイテムが有るか
            hasDraftList: function() {
                return (this.numOfDraftList > 0);
            },
        },
        methods: {
            // 下書き一覧取得
            getDraftList: async function () {
                let message = this.exception_error_message;
                try {
                    this.$_loading();
                    const response = await axios.get('/item/get_draft_list');
                    if (response.data.status === 'OK') {
                        // 下書きを代入
                        this.draft_list = response.data.data;
                        // エラーメッセージを空にする
                        message = '';
                    } else {
                        message = response.data.message;
                    }
                } catch (e) {
                    message = this.getCatchMessage(e);
                }
                if (message) console.error(message);
                this.$_unloading();
            },
            // ヤフーTOKEN認証チェック後に検索実行
            isValidToken: async function (boolean) {
                if (boolean) {
                    // 前回検索条件を取得
                    this.before_search_conditions = this.getBeforeSearchConditions();

                    if (this.before_search_conditions) {
                        // 前回検索条件データあるならページ表示時のカテゴリ検索を一旦無効にする
                        this.disabled_category_filter = true;
                        // カテゴリを設定
                        this.$refs.categoryFilter.setCategory(this.before_search_conditions.page_key);
                        // 前回検索条件を設定
                        this.$refs.item_search_condition.setSearchCondition(this.before_search_conditions.conditions);
                        // キーワード検索が行われていた場合検索エリアを開く
                        if (this.before_search_conditions.conditions.keyword) {
                            this.$refs.item_search_condition.toggleItemSearchArea();
                        }
                        // 検索
                        await this.$nextTick(function() {
                            this.$refs.item_search_condition.changeSort();
                            this.searchItems(this.before_search_conditions.current_page);
                        }, this);
                        // 検索が終わったらカテゴリ検索を有効にする
                        this.disabled_category_filter = false;
                    } else {
                        // 前回検索条件データなし
                        await this.firstSearch();
                    }

                    // 検索エラー
                    if (this.messages.length > 0) {
                        return;
                    }
                    // 商品ヒットなし、DBにカテゴリ登録なし → 初回案内画面
                    if (!this.hasItems && !this.has_categories) {
                        this.first_create = true;
                        return;
                    }
                    // 未開店、opening.itemが未完了 → 初回案内画面
                    this.$_loading();
                    if (!this.opened && !await this.isDoneTask('opening', 'item')) {
                        this.first_create = true;
                        this.$_unloading();
                        return;
                    }
                    this.$_unloading();
                    // 下書き一覧を取得する
                    await this.getDraftList();
                }
            },
            // 前回表示検索条件を取得する
            getBeforeSearchConditions: function() {
                // JSで使う用にレンダリングされたJSON文字列をデータとして取得
                const data = document.querySelector('[data-roll="search_conditions"]');
                if (!data) {
                    return null;
                }
                return JSON.parse(data.innerHTML);
            },
            // 検索条件を保存する
            saveSearchConditions: async function (conditions, current_page)  {
                try {
                    this.$_loading();
                    await axios.put('/item/save_search_conditions', {
                        'conditions': conditions,
                        'page_key': this.page_key,
                        'current_page': current_page,
                    });
                } catch (e) {
                    this.appendFlashMessage(
                        {
                            level: 'alert-danger',
                            message: this.getCatchMessage(e)
                        },
                    );
                }
                this.$_unloading();
            },
            // カテゴリー更新時処理
            onUpdatedCategory: async function (pageKey) {
                this.page_key = pageKey;
                this.$refs.item_search_condition.changeSort();

                if (!this.disabled_category_filter) {
                    this.$nextTick(async function() {
                        await this.searchItems(1);
                    }, this);
                }

                this.disabled_category_filter = false;
            },
            // カテゴリー一覧更新時処理
            onUpdatedCategoryList: function (categories) {
                this.categories = categories;
                this.has_categories = this.categories.length > 0 ? true : false;
            },
            // 商品リスト取得時処理
            onGetItemList: async function (searchedItems, conditions, currentPage) {
                this.item_list = searchedItems;
                // 商品有無
                if (this.hasItems) {
                    // 商品あり
                    // 検索条件を保存する
                    await this.saveSearchConditions(conditions, currentPage);
                } else {
                    // 商品0件
                    // 初回検索かつ商品がヒットしない場合はカテゴリ検索を行う
                    if(!this.has_searched && !this.before_search_conditions) {
                        this.$refs.categoryFilter.selectFirstCategory();
                    }
                }
                // 検索済みフラグをオンにする
                this.has_searched = true;
            },
            // ソート矢印の向きの初期化処理
            initSortArrow: async function () {
                this.$refs.item_list.initSortArrow();
            },
            // ソート矢印クリック時の処理
            onClickSort: async function (sort) {
                this.$refs.item_search_condition.changeSort(sort);

                this.$nextTick(async function() {
                    this.searchItems(1);
                }, this);
            }
        }
    });
};

if (document.querySelector(view)) {
    init();
}
